// extracted by css-extract-rspack-plugin
export default {"positionIndicatorWrapper":"_7c848834","positionIndicator":"_1ea4fd87"};